import { VendingPaymentChannels } from "../models/vending.model";

const smarpayColor = "#F18800";

const getRandomColor = () => "#" + Math.floor(Math.random() * 16777215).toString(16);

export const getRandomColorByChannel = (channel) => {
  let color = "black";

  switch (channel.toLowerCase()) {
    case VendingPaymentChannels.Twint.toLowerCase():
      color = "#FFCB00";
      break;
    case VendingPaymentChannels.SMSSunrise.toLowerCase():
      color = "#c60200";
      break;
    case VendingPaymentChannels.SMSSwisscom.toLowerCase():
      color = "#886235";
      break;
    case VendingPaymentChannels.SMSSalt.toLowerCase():
      color = "#BA4D7F";
      break;
    case VendingPaymentChannels.PostFinanceCard.toLowerCase():
      color = "#4061bf";
      break;
    case VendingPaymentChannels.PostFinanceCard2.toLowerCase():
      color = "#4061bf";
      break;
    case VendingPaymentChannels.PostFinanceCard3.toLowerCase():
      color = "#4061bf";
      break;
    case VendingPaymentChannels.CreditCard.toLowerCase():
      color = "#7e94d4";
      break;
    case VendingPaymentChannels.CreditCard2.toLowerCase():
      color = "#7e94d4";
      break;
    case VendingPaymentChannels.CreditCard3.toLowerCase():
      color = "#7e94d4";
      break;
    case VendingPaymentChannels.ApplePay.toLowerCase():
      color = "#074B66";
      break;
    case VendingPaymentChannels.ApplePay2.toLowerCase():
      color = "#074B66";
      break;
    case VendingPaymentChannels.GooglePay.toLowerCase():
      color = "#34ae25";
      break;
    case VendingPaymentChannels.GooglePay2.toLowerCase():
      color = "#34ae25";
      break;
    case VendingPaymentChannels.Cash.toLowerCase():
      color = "#981db8";
      break;
    case VendingPaymentChannels.TechPsp.toLowerCase():
      color = "#601db8";
      break;
    case VendingPaymentChannels.Cashless1.toLowerCase():
      color = "#a1b81d";
      break;
    case VendingPaymentChannels.MoneyStack.toLowerCase():
      color = "#b8391d";
      break;
    case VendingPaymentChannels.WalletExternal.toLowerCase():
      color = "#1db894";
      break;
    case VendingPaymentChannels.Reka.toLowerCase():
      color = "#91b81d";
      break;
    case VendingPaymentChannels.Mobile.toLowerCase():
      color = "#48e620";
      break;
    case VendingPaymentChannels.AmericanExpress.toLowerCase():
      color = "#b8b01d";
      break;
    case VendingPaymentChannels.AmericanExpress2.toLowerCase():
      color = "#b8b01d";
      break;
    case VendingPaymentChannels.MasterCard.toLowerCase():
      color = "#EB001B";
      break;
    case VendingPaymentChannels.MasterCard2.toLowerCase():
      color = "#EB001B";
      break;
    case VendingPaymentChannels.Visa.toLowerCase():
      color = "#1A1F71";
      break;
    case VendingPaymentChannels.Visa2.toLowerCase():
      color = "#1A1F71";
      break;
    case VendingPaymentChannels.Sms.toLowerCase():
      color = "#39fa32";
      break;
    case VendingPaymentChannels.DigitalWallet.toLowerCase():
      color = "#fc5a03";
      break;
    case VendingPaymentChannels.DigitalWallet2.toLowerCase():
      color = "#fc5a03";
      break;
    case VendingPaymentChannels.V_PAY.toLowerCase():
      color = "#db03fc";
      break;
    case VendingPaymentChannels.V_PAY2.toLowerCase():
      color = "#db03fc";
      break;
    case VendingPaymentChannels.MaestroCard.toLowerCase():
      color = "#eb001b";
      break;
    case VendingPaymentChannels.MaestroCard2.toLowerCase():
      color = "#eb001b";
      break;
    case VendingPaymentChannels.Smarpay.toLowerCase():
      color = "#F18800";
      break;
    case VendingPaymentChannels.Freevend.toLowerCase():
      color = "#491270";
      break;
    default:
      color = "black"; //getRandomColor()
      break;
  }

  return color;
};
